<script>
export default {
    name: 'IconStar'
}
</script>
<template>
    <svg
        class="base-icon icon-star"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M32 8l8.5 15L56 26 45.5 38.5 48 56l-16-8-16 8 2.5-17.5L8 26l15.5-3L32 8z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
